export default __webpack_public_path__ + "static/media/CO_intro_still.5ca8af4f.png";